module.exports = __webpack_public_path__ + "img/cv.c2194f79.svg";